<ion-list class="block-content-round ion-margin-top-0">
  <form
    [formGroup]="generalDataForm"
    appFormBlurNotifier
    (formBlurred)="emitModifiedData()"
    #blurNotifier="appFormBlurNotifier"
  >
    <div>
      <ion-grid>
        <ion-row>
          <ion-col
            sizeXl="2"
            sizeLg="3"
            sizeMd="4"
            size="12"
          >
            @if (costCenters$ | async; as costCenters) {
              <ion-select
                label="{{ 'freight.post.cost_center' | translate }}"
                interface="popover"
                label-placement="floating"
                fill="outline"
                mode="md"
                name="shipperCostCenter"
                formControlName="shipperCostCenter"
              >
                @for (costCenter of costCenters; track costCenter.id) {
                  <ion-select-option [value]="costCenter.id">{{ costCenter.name }}</ion-select-option>
                }
              </ion-select>
            }
          </ion-col>

          <ion-col
            sizeXl="4"
            sizeLg="9"
            sizeMd="8"
            size="12"
          >
            <ion-input
              placeholder="{{ 'freight.post.reference' | translate }}"
              label="{{ 'freight.post.reference' | translate }}"
              type="text"
              [counter]="true"
              maxlength="30"
              name="shipperFreightId"
              formControlName="shipperFreightId"
              labelPlacement="floating"
              fill="outline"
              mode="md"
              helperText="Introduzca una referencia para identificar la carga"
              errorText="Error. Introduzca una referencia para identificar la carga."
            ></ion-input>
          </ion-col>

          <ion-col
            sizeXl="3"
            sizeLg="6"
            sizeMd="6"
            size="12"
          >
            <ion-select
              label="{{ 'freight.post.vehicle_type' | translate }}"
              interface="popover"
              label-placement="floating"
              fill="outline"
              mode="md"
              multiple="true"
              name="transportType"
              formControlName="transportType"
              helperText="Seleccione al menos un tipo de vehículo"
              errorText="Error. Seleccione al menos un tipo de vehículo."
            >
              <ion-select-option value="CANVAS">{{ 'vehicleType.CANVAS' | translate }}</ion-select-option>
              <ion-select-option value="BOX">{{ 'vehicleType.BOX' | translate }}</ion-select-option>
              <!-- <ion-select-option value="REFRIGERATED">{{ 'vehicleType.REFRIGERATED' | translate }}</ion-select-option> -->
            </ion-select>
          </ion-col>

          <ion-col
            sizeXl="3"
            sizeLg="6"
            sizeMd="6"
            size="12"
          >
            <ion-select
              label="{{ 'freight.post.loading_type' | translate }}"
              interface="popover"
              label-placement="floating"
              fill="outline"
              mode="md"
              multiple="true"
              name="loadingType"
              formControlName="loadingType"
              helperText="Seleccione al menos una forma de carga"
              errorText="Error. Seleccione al menos una forma de carga."
            >
              <ion-select-option value="REAR">{{ 'freight.detail.loading_type.REAR' | translate }}</ion-select-option>
              <ion-select-option value="SIDE">{{ 'freight.detail.loading_type.SIDE' | translate }}</ion-select-option>
              <ion-select-option value="TOP">{{ 'freight.detail.loading_type.TOP' | translate }}</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>

        @if (showTemperatureFields) {
          <ion-row>
            <ion-col
              sizeMd="6"
              size="12"
            >
              Indique las temperaturas mínimas y máximas para la carga
            </ion-col>
            <ion-col
              sizeMd="3"
              size="6"
            >
              <ion-input
                placeholder="Mínima"
                label="Mínima"
                type="number"
                name="temperatureMin"
                formControlName="temperatureMin"
                labelPlacement="floating"
                fill="outline"
                mode="md"
                helperText="Obligatorio."
                errorText="Obligatorio."
              ></ion-input>
            </ion-col>
            <ion-col
              sizeMd="3"
              size="6"
            >
              <ion-input
                placeholder="Máxima"
                label="Máxima"
                type="number"
                name="temperatureMax"
                formControlName="temperatureMax"
                labelPlacement="floating"
                fill="outline"
                mode="md"
                helperText="Obligatorio."
                errorText="Obligatorio."
              ></ion-input>
            </ion-col>
          </ion-row>
        }

        <ion-row>
          <ion-col>
            <p class="ion-margin-bottom-0 fs-sm">
              <strong>{{ 'freight.post.optional_data' | translate }}</strong>
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            sizeXl="3"
            sizeLg="4"
            sizeMd="12"
            size="12"
          >
            <ion-row>
              <ion-col
                sizeLg="12"
                sizeMd="6"
                size="12"
              >
                <ion-toggle
                  labelPlacement="end"
                  [checked]="false"
                  name="deliveryNoteInPaper"
                  formControlName="deliveryNoteInPaper"
                >
                  {{ 'freight.post.delivery_note_in_paper' | translate }}
                </ion-toggle>
              </ion-col>
              <ion-col
                sizeLg="12"
                sizeMd="6"
                size="12"
              >
                <ion-toggle
                  labelPlacement="end"
                  [checked]="false"
                  name="field_waste"
                  formControlName="field_waste"
                >
                  {{ 'freight.post.waste_goods' | translate }}
                </ion-toggle>
              </ion-col>
            </ion-row>
          </ion-col>

          <ion-col
            sizeXl="9"
            sizeLg="8"
            sizeMd="12"
            size="12"
          >
            <ion-textarea
              label="{{ 'freight.post.instructions' | translate }}"
              placeholder="{{ 'freight.post.write_here' | translate }}"
              labelPlacement="floating"
              mode="md"
              fill="outline"
              [autoGrow]="true"
              [counter]="true"
              maxlength="250"
              spellcheck="true"
              name="instructions"
              formControlName="instructions"
            ></ion-textarea>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </form>
</ion-list>
